import React									from 'react';

import {LoadProps}								from './interface';

import img_load									from '../../images/loading.png';

import './Load.css';


function Load(props: LoadProps): JSX.Element {
	const style: React.CSSProperties = {};

	if (props.size) {
		style.maxHeight = props.size;
		style.maxWidth = props.size;
		style.minHeight = props.size;
		style.minWidth = props.size;
	}

	if (props.center) {
		return (
			<div className={'flex flex-center'}>
				<div className={'load'} style={style}>
					<img src={img_load} alt={'load'} />
				</div>
			</div>
		);
	}

	return (
		<div className={'load'} style={style}>
			<img src={img_load} alt={'load'} />
		</div>
	);
}

export default Load;